import API from "@/models/API";
import router from "@/routes"

let storesType = () => ((router?.history.current.path||'').split('/')||[])[2] == 'storePanel' ? 'stores':'companies'
    

export default class Shop {

    static getShopProducts = () =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/shop`
    );

    static getShopProduct = (id) =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/shop/${id}`
    );

    static buyShopProducts = (body) =>
    API.post(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/shop`, body
    );
    static buyShopThresholdProduct = (body) =>
    API.post(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/shop/buy-with-threshold`, body
    );
   
}
